import React from "react";
import i18n from "../../../i18n";

import { AvailableLanguagesEnum } from "../../../enums";

import UK from "../../../assets/img/common/uk.svg";
import SRSR from "../../../assets/img/common/serbian.svg";
import CRO from "../../../assets/img/common/croatian.svg";
import MNE from "../../../assets/img/common/macedonian.svg";
import SRBA from "../../../assets/img/common/republic_of_srpska.svg";

import { useAppDispatch } from "../../../store/hooks";
import { setLanguageIcon } from "../../../store/config-slice";

interface Props {
  language: string;
}

const Languages: React.FC<Props> = ({ language }) => {
  const changeLanguage = (lng: string | undefined): void => {
    i18n.changeLanguage(lng);
  };
  const dispatch = useAppDispatch();

  return (
    <div className="language_menu">
      <button
        type="button"
        className={`${"lng"} ${
          language === AvailableLanguagesEnum.SRBA && "selected_lng"
        }`}
        onClick={() => {
          changeLanguage("srba");
          dispatch(setLanguageIcon(AvailableLanguagesEnum.SRBA));
        }}
      >
        <img src={SRBA} alt="republic_of_srpska" />
        <div>{AvailableLanguagesEnum.SRBA}</div>
      </button>
      <button
        type="button"
        className={`${"lng"} ${
          language === AvailableLanguagesEnum.SRSR && "selected_lng"
        }`}
        onClick={() => {
          changeLanguage("srsr");
          dispatch(setLanguageIcon(AvailableLanguagesEnum.SRSR));
        }}
      >
        <img src={SRSR} alt="serbian" />
        <div>{AvailableLanguagesEnum.SRSR}</div>
      </button>
      <button
        type="button"
        className={`${"lng"} ${
          language === AvailableLanguagesEnum.MNE && "selected_lng"
        }`}
        onClick={() => {
          changeLanguage("srba");
          dispatch(setLanguageIcon(AvailableLanguagesEnum.MNE));
        }}
      >
        <img src={MNE} alt="montenegro" />
        <div>{AvailableLanguagesEnum.MNE}</div>
      </button>
      <button
        type="button"
        className={`${"lng"} ${
          language === AvailableLanguagesEnum.CRO && "selected_lng"
        }`}
        onClick={() => {
          changeLanguage("srba");
          dispatch(setLanguageIcon(AvailableLanguagesEnum.CRO));
        }}
      >
        <img src={CRO} alt="croatian" />
        <div>{AvailableLanguagesEnum.CRO}</div>
      </button>
      <button
        type="button"
        className={`${"lng"} ${
          language === AvailableLanguagesEnum.ENG && "selected_lng"
        }`}
        onClick={() => {
          changeLanguage("en");
          dispatch(setLanguageIcon(AvailableLanguagesEnum.ENG));
        }}
      >
        <img src={UK} alt="english" />
        <div>{AvailableLanguagesEnum.ENG}</div>
      </button>
    </div>
  );
};

export default Languages;
